import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer, Provider} from 'mobx-react';
import {withRouter, locationShape, routerShape} from 'react-router';

import {withConfig, withI18n} from 'spa/Components/Context';

import AppState from '../../state/app';

import TherapistSingle from './TherapistSingle';

import WorkerState from './workerState';

@withRouter
@inject('store')
@observer
@withI18n
@withConfig
class Worker extends React.Component {
  static propTypes = {
    store: PropTypes.instanceOf(AppState).isRequired,
    router: routerShape.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
      stub: PropTypes.string,
    }),
    location: locationShape.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.workerState = new WorkerState(this.props.store);
  }

  render() {
    return (
      <Provider therapistsState={this.workerState} params={this.props.params}>
        <TherapistSingle />
      </Provider>
    );
  }
}

export default Worker;



// WEBPACK FOOTER //
// ./spa/Pages/Therapists/Worker.jsx